import React, { Fragment, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { serverApi } from "../../../../../config/Keys";
import axios from "axios";
import Alert from "react-s-alert";
import { useSelector } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";
import QRCode from "qrcode";

function MenuListComposition(props) {
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const [qrcode, setQRCode] = useState("");

  useEffect(() => {
    const generateQR = async () => {
      if (!qrcode) {
        await QRCode.toDataURL(
          JSON.stringify({
            event_id: props?.dataProps?.event_id,
            name: props?.data?.user_details?.name,
            event_request_id: props?.data?.event_request_id,
            event_type: props?.data?.event_type,
          }),
          function (err, url) {
            if (err) return console.log("error occured");
            setQRCode(url);
          }
        );
      }
    };
    generateQR();
  }, [props?.data?._id]);

  const share = async (e, type) => {
    handleToggle();
    let formData = {
      event_request_id: props?.data?._id,
      sms: type === 1 ? true : null,
      email: type === 2 ? true : null,
      link: `${window?.location?.origin}/ticketbooked/${props?.data?._id}`,
      qrcode: qrcode,
    };
    try {
      let response = await axios.post(
        `${serverApi}/vendor/event-handler`,
        formData,
        {
          headers: {
            Authorization: auth.accessToken,
          },
        }
      );
      if (response.status === 201) {
        Alert.success(`<h4>Content shared successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      console.log(response);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Fragment>
      <div>
        {/* <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
         
        > */}
        <Button
          variant="link"
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          className="enIconBtn mt-3 mb-3"
          onClick={handleToggle}
        >
          <i
            class="fa fa-share-alt"
            style={{ color: "#8a8a8a" }}
            aria-hidden="true"
          ></i>
        </Button>
        {/* </Button> */}
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          style={{ zIndex: "1500" }}
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
                zIndex: "1500",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={(e) => share(e, 1)}>
                      Share via SMS
                    </MenuItem>
                    <MenuItem onClick={(e) => share(e, 2)}>
                      Share via E-mail
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Fragment>
  );
}

function ShareButtonEventsTicket(props) {
  return (
    <MenuListComposition data={props?.data} dataProps={props?.dataProps} />
  );
}

export default ShareButtonEventsTicket;
